import React, { useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const faqs = [
  {
    id: "faq-1-1",
    question: "1.1. What is UpskillMeet and how does it work?",
    answer: (
      <>
        UpskillMeet is a collaborative platform that connects individuals with expertise to those eager to learn or seek guidance across a wide range of skills and domains.
        <br />
        Anyone with knowledge to share can offer their services as an Expert, and anyone seeking to learn can engage as an Explorer.
        <br />
        Beyond one on one sessions, UpskillMeet also features a social layer:
        <ul>
          <li>Users can follow others and gain followers, enabling ongoing learning and connection.</li>
          <li>A public showcase space lets users share photos, videos, documents, or written content to highlight their skills and accomplishments.</li>
        </ul>
        UpskillMeet is a marketplace ,it's a growing community where people come together to share knowledge, build their personal brand, and form meaningful professional connections.
      </>
    )
  },
  {
    id: "faq-1-2",
    question: "1.2. Who can join UpskillMeet?",
    answer: (
      <>
        Anyone with a passion to learn, teach, or share knowledge is welcome to join UpskillMeet.
        <br /><br />
        Whether you're a student, professional, hobbyist, educator, freelancer, or simply someone with a skill to offer or a curiosity to explore—UpskillMeet is built for you.
        <br /><br />
        There are no restrictions based on profession, age, or qualification. If you have something to learn or something to share, you can be part of the community.
        <br /><br />
        You can:
        <ul>
          <li>Offer your expertise in any area you're confident in</li>
          <li>Discover and book sessions to grow your skills</li>
          <li>Share content, follow others, and build meaningful connections</li>
        </ul>
        UpskillMeet is open, inclusive, and designed to empower lifelong learning and skill-sharing for everyone.
      </>
    )
  },
  {
    id: "faq-1-3",
    question: "1.3. I want to offer services or book sessions—how does that work?",
    answer: (
      <>
        To offer services as an Expert or to book sessions as an Explorer on UpskillMeet, you’ll need to upgrade to a Premium account by paying a small platform fee. You can choose a plan that will be convenient for you.
        <br /><br />
        Here's how it works:
        <ul>
          <li>
            Basic users can freely access the platform, browse expert profiles, explore public content, and showcase their skills through photos, videos, documents, and posts.
          </li>
          <li>
            Premium users unlock full access to the platform—allowing them to offer services, receive bookings, and book sessions with others.
          </li>
        </ul>
        This simple premium model helps ensure quality engagement, reduce spam, and support the growth of our expert community.
        <br /><br />
        <a href="myspace/subscription" style={{ color: "#ffffffff", textDecoration: "underline" }}>
          Click here to avail Premium membership
        </a>
      </>
    )
  },
  {
    id: "faq-1-4",
    question: "1.4. What kind of services or sessions are available?",
    answer: (
      <>
        On UpskillMeet, users can offer services based on the Subject Matter Expertise (SME) listed in their profile. The platform supports two main service types:
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>1. Upskilling Services</strong>
        <br />
        These are designed for explorers looking to build or improve specific skills. Experts can choose to offer:
        <ul>
          <li>Single sessions</li>
          <li>Weekly sessions</li>
          <li>Monthly sessions</li>
          <li>Or a combination of all three</li>
        </ul>
        This flexibility allows experts to structure their teaching based on the learner’s needs—whether it's a one time deep dive or ongoing mentorship.
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>2. Business Consulting Services</strong>
        <br />
        These are tailored for users offering strategic advice or professional consulting.<br />
        Unlike upskilling services, there are no session bookings involved here—experts simply display their consulting service details, including pricing, to inform interested clients.
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        UpskillMeet is designed to accommodate both educators and consultants, offering structured flexibility for service delivery and discovery.
      </>
    )
  },
  {
    id: "faq-1-5",
    question: "1.5. Are the experts on UpskillMeet verified or qualified?",
    answer: (
      <>
        UpskillMeet does not conduct formal verification of qualifications or credentials. All users go through a basic email verification process to access the platform.
        <br /><br />
        To help users make informed decisions when choosing someone to learn from or collaborate with, we provide several transparency features available to all members:
        <ul>
          <li>
            <strong>Detailed User Profiles:</strong> Every profile includes information such as subject matter expertise, skills, services offered, education, languages spoken, and more.
          </li>
          <li>
            <strong>Embedded Showcase Content:</strong> Users can share embedded videos from platforms like YouTube, Facebook, Instagram, and LinkedIn, along with photos, documents, and written posts to highlight their abilities and achievements.
          </li>
          <li>
            <strong>Testimonials & Reviews:</strong> After each session, Explorers can leave honest feedback, which appears publicly on the user's profile.
          </li>
          <li>
            <strong>Promotion Section:</strong> Users can showcase brand collaborations, certifications, or special recognitions.
          </li>
          <li>
            <strong>Followers & Engagement:</strong> The ability to follow users and see their content/activity helps build trust and community reputation.
          </li>
        </ul>
        Explorers are encouraged to review profiles, showcase content, testimonials, and public activity to assess the credibility of anyone they’re considering booking a session with.
      </>
    )
  },
	 {
    id: "faq-2-1",
    question: "2.1. How do I book a session with an expert?",
    answer:(
      <>
        Booking a session on UpskillMeet is a simple two step process:
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>Step 1: Raise a Query</strong>
        <br />
        Before you can book, you must send a query to the expert to request a session.
        <ul>
          <li>Visit the Expert’s profile</li>
          <li>Go to the “Queries” tab</li>
          <li>
            Choose:
            <ul>
              <li>Service Type: Upskilling or Business Consulting</li>
              <li>Subject Area (e.g., VLSI, UI Design, Digital Marketing)</li>
              <li>Session Format: Single, Weekly, or Monthly (based on the expert's offering)</li>
            </ul>
          </li>
          <li>Optionally, add a personalized message in the comments box</li>
          <li>Click Send</li>
        </ul>
         Booking is only possible if the expert accepts your query.
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>Step 2: Book and Pay</strong>
        <br />
        Once your query is approved:
        <ul>
          <li>Go to the “Services” section of the expert’s profile</li>
          <li>Choose a convenient date and time slot from the expert’s availability</li>
          <li>Click “Book” this will redirect you to the payment gateway</li>
          <li>Complete the payment to confirm your session</li>
        </ul>
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>After Successful Payment</strong>
        <ul>
          <li>The session will be officially booked</li>
          <li>Both the Explorer and the Expert will receive an email with session details and next steps</li>
        </ul>
      </>
    )
  },
  {
    id: "faq-2-2",
    question: "2.2. How do I create a profile and list my services?",
    answer:  (
      <>
        Creating your profile and listing services is a straightforward process. Here’s a step by step guide:
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>Step 1: Create Your Profile</strong>
        <ul>
          <li>Sign up on UpskillMeet and complete OTP verification.</li>
          <li>You’ll be redirected to a basic profile setup page:
            <ul>
              <li>Some fields are mandatory (e.g., name, expertise)</li>
              <li>Other fields can be filled later</li>
            </ul>
            This creates a partial profile. You can complete the full profile at any time.
          </li>
          <li>To complete your profile:
            <ul>
              <li>Log in and go to MySpace &gt; Info</li>
              <li>Fill in additional details like your education, experience, languages, and subject matter expertise (SME)</li>
            </ul>
          </li>
        </ul>
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>Step 2: Upgrade to a Premium Plan</strong>
        <ul>
          <li>To list your services:</li>
          <li>Go to MySpace &gt; Info &gt; My Subscription</li>
          <li>Choose and activate a Premium Plan by paying a small platform fee</li>
        </ul>
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>Step 3: Enable and Add Services</strong>
        <ul>
          <li>After upgrading:</li>
          <li>Navigate to MySpace &gt; Calendar
            <ul>
              <li>Fill in your availability and other basic info</li>
            </ul>
          </li>
          <li>Go to MySpace &gt; Services
            <ul>
              <li>Toggle “Services Offered” to ON</li>
              <li>Select one or both:
                <ul>
                  <li>Upskilling Services</li>
                  <li>Business Consulting Services</li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>Adding Service Details</strong>
        <ul>
          <li>
            <strong>Upskilling Services:</strong>
            <ul>
              <li>Click “Add”, then choose your session type:
                <ul>
                  <li>Single Session</li>
                  <li>Weekly Sessions</li>
                  <li>Monthly Sessions</li>
                </ul>
              </li>
              <li>Set your pricing for each session type</li>
              <li>Click Save</li>
            </ul>
          </li>
          <li>
            <strong>Business Consulting Services:</strong>
            <ul>
              <li>Enter the consultation fee</li>
              <li>Click Save</li>
            </ul>
          </li>
        </ul>
        Once saved, your services will be visible to Explorers, and you can start receiving queries and bookings.
      </>
    )
  },
  {
    id: "faq-2-3",
    question: "2.3. Can I message or contact someone before booking?",
    answer: (
      <>
        Currently, there is no direct chat feature available before booking a session.<br />
        However, you can still reach out to an expert by raising a query from their profile. This is the only way to express your interest or ask a question before booking.
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>How Queries Work:</strong>
        <ul>
          <li>
            <strong>Single Session:</strong>
            <ul>
              <li>You raise a query stating the type of assistance and expertise required.</li>
              <li>The expert can accept or reject the query.</li>
              <li>Once the expert responds, the query is closed.You will need to raise a new query for any further interaction.</li>
            </ul>
          </li>
          <li>
            <strong>Weekly or Monthly Sessions:</strong>
            <ul>
              <li>If your query is accepted and the booking is confirmed, a chat window will automatically open.</li>
              <li>This chat remains active throughout the duration of the session plan, allowing smooth communication with the expert.</li>
            </ul>
          </li>
        </ul>
        <strong>Please note:</strong> Chat is not available for single session bookings,even after acceptance. Interaction for single sessions is limited to the query step only.
      </>
    )
  },
  {
    id: "faq-2-4",
    question: "2.4. Can sessions be rescheduled or cancelled?",
    answer: (
      <>
        Yes, sessions on UpskillMeet can be rescheduled or cancelled by either the expert or the explorer, but only with mutual agreement. The system ensures both parties are informed and involved at every step.
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>When an Expert wants to reschedule or cancel:</strong>
        <ul>
          <li>The expert raises a reschedule or cancel request.</li>
          <li>The explorer receives a notification and email.</li>
          <li>The explorer can then:
            <ul>
              <li>Accept the new time and reschedule the session.</li>
              <li>Reject the new time and proceed with the originally booked session.</li>
              <li>Cancel the session if the revised time isn’t suitable.</li>
            </ul>
          </li>
        </ul>
        The session will only be updated or cancelled if the explorer takes action on the expert’s request.
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>When an Explorer wants to reschedule or cancel:</strong>
        <ul>
          <li>The explorer can go to MySpace &gt; Bookings, click the three vertical dots next to the session, and select "Reschedule" or "Cancel".</li>
          <li>After the action:
            <ul>
              <li>Both expert and explorer receive notifications and emails.</li>
              <li>If rescheduled, the expert can accept, or raise a new request if needed.</li>
            </ul>
          </li>
        </ul>
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>For Weekly and Monthly Sessions:</strong>
        <ul>
          <li>Weekly and monthly sessions have an active chat window between the expert and the explorer.</li>
          <li>You can use the chat to discuss any changes before raising a formal reschedule or cancel request.</li>
          <li>This makes coordination easier and more transparent.</li>
        </ul>
        <strong>Note:</strong> Single sessions do not have chat functionality, even after booking.
      </>
    )
  },
  {
    id: "faq-2-5",
    question: "2.5. How will I know if a session is confirmed?",
    answer: (
      <>
        Once a session is successfully booked on UpskillMeet:
        <ul>
          <li>Both the expert and the explorer receive a confirmation email and an in app notification.</li>
        </ul>
        <strong>The confirmation includes:</strong>
        <ul>
          <li>Session details (date, time, session type, topic)</li>
          <li>Any next steps or instructions to follow</li>
        </ul>
        <strong>Track Your Upcoming Sessions Easily</strong>
        <ul>
          <li>All your confirmed sessions are also visible in the “Upcoming Sessions” tab</li>
        </ul>
        This tab is always accessible on every page, making it easy to stay updated and manage your schedule on the go.<br />
        You can also view and manage all your sessions from <strong>MySpace &gt; Bookings</strong>.
      </>
    )
  },
  {
    id: "faq-2-6",
    question: "2.6. Where do I enter the OTP?",
    answer: (
      <>
        <ul>
          <li>Experts can enter the Start and End OTPs from the MySpace &gt; Bookings section.</li>
          <li>From 10 minutes before the scheduled start time until the session ends:
            <ul>
              <li>Click on the three vertical dots next to the Join button.</li>
              <li>You’ll see options to Enter Start OTP and Enter End OTP.</li>
            </ul>
          </li>
          <li>These options are only visible to the expert and will disappear after the session is completed.</li>
        </ul>
      </>
    )
  },
  {
    id: "faq-2-7",
    question: "2.7. Why is the OTP important?",
    answer: (
      <>
        <ul>
          <li>The OTP system ensures that the session was conducted as scheduled.</li>
          <li>It helps maintain trust and transparency between experts and explorers.</li>
          <li>It is also essential for the smooth processing of expert payments, confirming that the session took place.</li>
        </ul>
      </>
    )
  },
  {
    id: "faq-2-8",
    question: "2.8. How do I get the OTP?",
    answer: (
      <>
        <ul>
          <li>
            <strong>Start OTP:</strong>
            <ul>
              <li>Sent to the explorer via email once the session is successfully booked.</li>
              <li>Shared by the explorer with the expert at the beginning of the session.</li>
            </ul>
          </li>
          <li>
            <strong>End OTP:</strong>
            <ul>
              <li>Sent to the explorer after the session begins.</li>
              <li>Shared with the expert at the end of the session to confirm completion.</li>
            </ul>
          </li>
        </ul>
        The expert must collect and enter both OTPs to mark the session as successfully completed.
      </>
    )
  },
  {
    id: "faq-3-1",
    question: "3.1. How much do sessions cost and who sets the price?",
    answer: (
      <>
        The cost of each session is set entirely by the expert.
        <ul>
          <li>There is no fixed or platform mandated pricing.</li>
          <li>Experts decide their own rates based on their experience, subject expertise, and type of session (single, weekly, or monthly).</li>
          <li>As an explorer, you can view the pricing on the expert’s profile and decide based on your preferences and budget.</li>
        </ul>
        UpskillMeet does not interfere with pricing—our role is to provide the platform and ensure smooth transactions.
      </>
    )
  },
  {
    id: "faq-3-2",
    question: "3.2. How do payments work on UpskillMeet?",
    answer: (
      <>
        <ul>
          <li>When an explorer books a paid session, the payment is made upfront at the time of booking.</li>
          <li>The payment is held securely by UpskillMeet until the payout cycle.</li>
        </ul>
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>Expert Payouts:</strong>
        <ul>
          <li>All expert earnings from completed sessions are accumulated monthly.</li>
          <li>Payouts are processed on the last Thursday of every month and transferred to the expert’s registered bank account.</li>
          <li>Experts can track their payments and manage bank details in MySpace &gt; Payments &gt; Bank Account.</li>
        </ul>
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>Why this process?</strong>
        <ul>
          <li>This payout schedule allows the platform to:</li>
          <li>Verify session completion (via OTP and feedback).</li>
          <li>Resolve any disputes or issues related to the session.</li>
          <li>Ensure a smooth and transparent payment process for all parties.</li>
        </ul>
        UpskillMeet acts as a trusted intermediary to protect both experts and explorers.
      </>
    )
  },
  {
    id: "faq-3-3",
    question: "3.3. Are there any hidden charges?",
    answer: (
      <>
        No, there are absolutely no hidden fees on UpskillMeet.
        <ul>
          <li>To book sessions or offer services, users must subscribe to a Premium Plan.</li>
          <li>The Premium Plan is a recurring subscription, and users can choose from:
            <ul>
              <li>3 months</li>
              <li>6 months</li>
              <li>12 months options based on their needs.</li>
            </ul>
          </li>
          <li>Once subscribed:
            <ul>
              <li>Explorers only pay the expert’s session fee—no additional platform charges.</li>
              <li>Experts receive the full amount they charge for each session, UpskillMeet takes zero commission.</li>
            </ul>
          </li>
        </ul>
        Our pricing is simple, transparent, and designed to empower both learners and experts.
      </>
    )
  },
  {
    id: "faq-3-4",
    question: "3.4. When and how do experts get paid?",
    answer: (
      <>
        <ul>
          <li>Experts are paid monthly for all sessions that were successfully completed, the amount for these sessions are accumulated.</li>
          <li>The payout is processed on the last Thursday of every month.</li>
        </ul>
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>How do experts receive their payments?</strong>
        <ul>
          <li>Experts must add their bank account details by going to: MySpace &gt; Payments &gt; Bank Account</li>
          <li>All payouts are directly transferred to the registered bank account.</li>
        </ul>
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>Track Your Earnings</strong>
        <ul>
          <li>Experts can view:</li>
          <ul>
            <li>Total earnings</li>
            <li>Upcoming payouts</li>
            <li>Payment history</li>
          </ul>
          <li>This is available in the MySpace &gt; Payments section.</li>
        </ul>
        UpskillMeet ensures timely, transparent, and commission free payments to all experts.
      </>
    )	
  },
  {
    id: "faq-3-5",
    question: "3.5. Do explorers get a refund if a session is cancelled?",
    answer: (
      <>
        Yes, refunds are available, but they depend on when the cancellation occurs:
        <ul>
          <li>
            <strong>Full Refund:</strong> If the explorer cancels at least 24 hours before the session start time, they receive a 100% refund.
          </li>
          <li>
            <strong>No Refund:</strong> If the session is cancelled within 24 hours, no refund is provided. This respects the expert’s time and potential scheduling conflicts.
          </li>
        </ul>
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>Why is there a deduction for late cancellations?</strong>
        <br />
        Within 24 hours, it becomes difficult for the expert to fill the slot with another session. The deduction compensates the expert for their time and potential lost opportunity.
        <br /><br />
        We aim to balance fairness between explorers and experts to ensure a reliable and respectful learning environment.
      </>
    )
  },
  {
    id: "faq-3-6",
    question: "3.6. How are sessions conducted?",
    answer: (
      <>
        All sessions on UpskillMeet are conducted through Google Meet.
        <ul>
          <li>Booking happens within the UpskillMeet platform, where explorers can choose available time slots and complete the payment.</li>
          <li>After booking, both the explorer and expert receive the Google Meet link via email and on the platform.</li>
          <li>The session can be joined directly through UpskillMeet MySpace &gt; Bookings &gt; Upcoming.</li>
        </ul>
        Google Meet ensures secure, high quality video sessions without requiring additional installations for most users.
      </>
    )
  },
  {
    id: "faq-3-7",
    question: "3.7. What happens if someone misses a session?",
    answer: (
      <>
        UpskillMeet has a "No Show" feature to handle missed sessions fairly for both explorers and experts.
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>If the Explorer (mentee) misses the session:</strong>
        <ul>
          <li>The expert can mark the session as "No Show" by:
            <ul>
              <li>Going to MySpace &gt; Bookings &gt; Upcoming</li>
              <li>Clicking the three vertical dots next to the session (in the Start OTP popup)</li>
              <li>Selecting the "No Show" option</li>
            </ul>
          </li>
          <li>This lets us know the explorer didn’t attend, and in this case, the expert will receive full payment.</li>
        </ul>
        <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "16px 0" }} />
        <strong>If the Expert misses the session:</strong>
        <ul>
          <li>The explorer can mark the expert as "No Show" by:
            <ul>
              <li>Visiting MySpace &gt; Bookings &gt; Upcoming</li>
              <li>Clicking the "No Show" button next to the Join button</li>
            </ul>
          </li>
          <li>This notifies us that the expert failed to show up, and the explorer will receive a full refund.</li>
        </ul>
        The No Show option is available only for a short window during and immediately after the scheduled session time.
      </>
    )
  },
  {
    id: "faq-3-8",
    question: "3.8. Can explorer leave feedback or rate the expert?",
    answer: (
      <>
        Yes, explorers can leave feedback and rate the expert after every completed session.
        <br /><br />
        <strong>How?</strong>
        <ul>
          <li>After the session ends, the explorer receives an email with a link to the feedback form.</li>
          <li>The feedback form is also available in:<br />
            MySpace &gt; Bookings &gt; Completed &rarr; next to the relevant session.
          </li>
        </ul>
      </>
    )
  },
  {
    id: "faq-3-9",
    question: "3.9. Can experts also leave feedback?",
    answer: (
      <>
        Yes, experts can also share feedback about the session.
        <ul>
          <li>They’ll receive a feedback form via email</li>
          <li>It will also appear in their MySpace &gt; Bookings &gt; Completed section</li>
        </ul>
        Two way feedback helps improve trust, quality, and the overall learning experience on UpskillMeet.
      </>
    )
  },
  {
    id: "faq-3-10",
    question: "3.10. Can experts showcase client reviews?",
    answer: (
      <>
        Yes, explorers can leave testimonials after a session, and these reviews are publicly visible.
        <br /><br />
        <strong>Where are testimonials displayed?</strong>
        <ul>
          <li>A few selected testimonials appear on the expert’s profile page, providing quick insight into their credibility.</li>
          <li>A “View More” button opens a dedicated testimonials page, where all feedback (both positive and negative) is transparently displayed.</li>
        </ul>
        This helps explorers make informed decisions and allows experts to build trust through real, experience based reviews.
      </>
    )
  },
  {
    id: "faq-3-11",
    question: "3.11. Will I get notes, materials, or recordings after the session?",
    answer: (
      <>
        Since sessions are conducted via Google Meet, UpskillMeet does not directly provide features for note taking or recordings within the platform.
        <ul>
          <li>Experts and explorers are free to use Google Meet features, such as screen sharing, live captions, or recordings (if enabled).</li>
          <li>Any notes, materials, or recordings shared are at the discretion of the expert.</li>
        </ul>
        We recommend discussing beforehand if the expert will provide follow up resources or session summaries.
      </>
    )
  },
  {
    id: "faq-4-1",
    question: "4.1. What are Posts on UpskillMeet?",
    answer: (
      <>
        Posts are a way for users ,especially experts to share their knowledge, achievements, certifications, brand collaborations, or valuable insights. It helps other users discover and engage with relevant expertise.
      </>
    )
  },
  {
    id: "faq-4-2",
    question: "4.2. Who can create posts?",
    answer: (
      <>
        Any registered user can create posts. You do not need a Premium Plan to post. Whether you're an expert showcasing your skills or an explorer sharing experiences, you're free to contribute.
      </>
    )
  },
  {
    id: "faq-4-3",
    question: "4.3. What kind of content can be shared in a post?",
    answer: (
      <>
        Posts can include:
        <ul>
          <li>Text content</li>
          <li>Photos and documents</li>
          <li>Embedded videos from platforms like YouTube, Instagram, Facebook, and LinkedIn</li>
        </ul>
        This makes it easy to share accomplishments, insights, or promotions effectively.
      </>
    )
  },
  {
    id: "faq-4-4",
    question: "4.4. Why is there no comment section on posts?",
    answer: (
      <>
        To preserve a professional, respectful environment, the comment section is intentionally removed.<br />
        We found that public comments were often misused for:
        <ul>
          <li>Spamming and sel promotion</li>
          <li>Publicly trashing experts or services</li>
          <li>Off topic discussions that distracted from the post's intent</li>
        </ul>
        Feedback is best delivered via queries, testimonials, or direct communication during sessions.
      </>
    )
  },
  {
    id: "faq-4-5",
    question: "4.5. Can posts be reported?",
    answer: (
      <>
        Yes. If a post violates our guidelines or seems inappropriate, it can be reported. Once reported, the post will be temporarily hidden while it's reviewed by our moderation team.
      </>
    )
  },
  {
    id: "faq-4-6",
    question: "4.6. Can I promote my brand or certifications through posts?",
    answer: (
      <>
        Absolutely. Users are encouraged to share posts highlighting certifications, brand partnerships, successful sessions, or educational content. It’s a great way to build credibility and visibility on the platform.
      </>
    )
  },
  {
    id: "faq-4-7",
    question: "4.7. Who can post promotions?",
    answer: (
      <>
        Any member with a Premium plan can post a promotion in the promotion column.
      </>
    )
  },
  {
    id: "faq-4-8",
    question: "4.8. Will I be charged for my promotion?",
    answer: (
      <>
        No, a user with Premium plan can post any number of promotions and will not be charged for that.
      </>
    )
  },
  {
    id: "faq-5-1",
    question: "5.1. Is my personal and payment information secure?",
    answer: (
      <>
        Yes, your personal and payment information is completely secure on UpskillMeet.
        <ul>
          <li>We do not share your data with any third parties.</li>
          <li>Sensitive details like your phone number, WhatsApp number, and email ID are used only for essential platform communication (e.g., notifications, session updates).</li>
          <li>These details are not visible on your public profile and are never shared with other users.</li>
        </ul>
        We are committed to protecting your privacy and ensuring a safe experience on the platform.
      </>
    )
  },
  {
    id: "faq-5-2",
    question: "5.2. What should I do if I face any issues during a session?",
    answer: (
      <>
        While issues are rare, since sessions are conducted via Google Meet, a reliable platform — here’s what you can do if something goes wrong:
        <ul>
          <li>Session links are generated immediately upon booking and shared via email and in your bookings section.</li>
          <li>If you face technical difficulties, no shows, or other concerns, you can reach our support team anytime at:<br /><strong>support@upskillmeet.com</strong></li>
        </ul>
        We’re here to ensure your experience is smooth and that any issues are resolved promptly.
      </>
    )
  },
  {
    id: "faq-5-3",
    question: "5.3. Is there a way to report inappropriate behaviours?",
    answer: (
      <>
        Yes, UpskillMeet takes user safety seriously and provides multiple ways to report concerns:
        <ul>
          <li>
            <strong>Reporting Posts:</strong><br />
            Any user can report a post they find inappropriate. Reported posts are temporarily hidden, reviewed by our team, and removed if found in violation of our guidelines.
          </li>
          <li>
            <strong>Reporting Users:</strong><br />
            If you encounter inappropriate behaviour from another user:
            <ul>
              <li>You can block the user directly from their profile.</li>
              <li>You can also raise a complaint by emailing <strong>support@upskillmeet.com</strong> with relevant details.</li>
            </ul>
          </li>
        </ul>
        We encourage all users to help us maintain a respectful and professional environment on the platform.
      </>
    )
  },
  {
    id: "faq-5-4",
    question: "5.4. Is there a review or rating system?",
    answer: (
      <>
        UpskillMeet does not use a star or numeric rating system.<br /><br />
        Instead, after each session:
        <ul>
          <li>Explorers can write detailed testimonials about their experience with an expert.</li>
          <li>These testimonials are displayed on the expert’s profile and help future explorers make informed decisions.</li>
          <li>A dedicated Testimonial Page showcases all feedback, both positive and constructive, received by each expert.</li>
        </ul>
        We believe in the value of written feedback over ratings to give a clearer picture of an expert's impact.
      </>
    )
  },
  {
    id: "faq-6-1",
    question: "6.1. Who do I contact if I need help?",
    answer: (
      <>
        If you have any questions, face an issue, or need assistance at any point, you can reach our support team at:<br />
        <strong>support@upskillmeet.com</strong>
        <br /><br />
        We’re here to help. Whether it's a technical problem, account question, or feedback about your experience.
      </>
    )
  },
  {
    id: "faq-6-2",
    question: "6.2. Is there a support team or community for users?",
    answer: (
      <>
        Yes! UpskillMeet has a dedicated support team ready to assist you.
        <ul>
          <li>For any queries, issues, or feedback, just email us at <strong>support@upskillmeet.com</strong>.</li>
          <li>You’ll receive a prompt and helpful response from our team.</li>
        </ul>
        We're committed to providing a smooth and supportive experience for all users.
      </>
    )
  },
];

const FAQ = () => {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(null);

  const filteredFaqs = faqs.filter(
    faq =>
      faq.question.toLowerCase().includes(search.toLowerCase()) ||
      (typeof faq.answer === "string"
        ? faq.answer.toLowerCase().includes(search.toLowerCase())
        : false)
  );

  const handleToggle = id => {
    setOpen(open === id ? null : id);
  };

  return (
    <div className="card card-one-1 margin faq-wrapper">
      <Navbar />
      <div className="faq-static-content">
        <div className="static-header">
          <h1 className="container">Frequently Asked Questions</h1>
        </div>
        <div className="container mt-3" style={{ maxWidth: "1000px", margin: "0 auto" }}>
          {/* Search Bar */}
          <div style={{ textAlign: "center", marginBottom: "32px" }}>
            <input
              type="text"
              placeholder="Search FAQs..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{
                width: "80%",
                padding: "12px",
                fontSize: "18px",
                borderRadius: "8px",
                border: "1px solid #ccc"
              }}
            />
          </div>
          {/* FAQ Accordion */}
          <div>
            {/* Section 1: General About the Platform */}
            {filteredFaqs.some(faq => faq.id.startsWith("faq-1-")) && (
              <h4 style={{ marginBottom: "24px", textAlign: "center", fontWeight:"bold" }}>
                General About the Platform
              </h4>
            )}
            {filteredFaqs
              .filter(faq => faq.id.startsWith("faq-1-"))
              .map(faq => (
                <div
                  key={faq.id}
                  style={{
                    background: "#1c5b9a",
                    color: "#fff",
                    borderRadius: "20px",
                    marginBottom: "18px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                    overflow: "hidden"
                  }}
                >
                  <button
                    onClick={() => handleToggle(faq.id)}
                    style={{
                      width: "100%",
                      background: "none",
                      border: "none",
                      color: "#fff",
                      textAlign: "left",
                      padding: "24px",
                      fontSize: "20px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <span>
                      {faq.question.replace(/^(\d+\.\d+\.\s*)/, "")}
                    </span>
                    <span style={{
                      fontSize: "28px",
                      fontWeight: "bold"
                    }}>
                      {open === faq.id ? "−" : "+"}
                    </span>
                  </button>
                  {open === faq.id && (
                    <div style={{
                      background: "#1c5b9a",
                      padding: "20px 24px",
                      fontSize: "17px",
                      color: "#eee",
                      lineHeight: "2"
                    }}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))
            }
            {/* Section 2: Booking & Scheduling */}
            {filteredFaqs.some(faq => faq.id.startsWith("faq-2-")) && (
              <h4 style={{ margin: "40px 0 24px 0", textAlign: "center", fontWeight:"bold" }}>
                Booking & Scheduling
              </h4>
            )}
            {filteredFaqs
              .filter(faq => faq.id.startsWith("faq-2-"))
              .map(faq => (
                <div
                  key={faq.id}
                  style={{
                    background: "#1c5b9a",
                    color: "#fff",
                    borderRadius: "20px",
                    marginBottom: "18px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                    overflow: "hidden"
                  }}
                >
                  <button
                    onClick={() => handleToggle(faq.id)}
                    style={{
                      width: "100%",
                      background: "none",
                      border: "none",
                      color: "#fff",
                      textAlign: "left",
                      padding: "24px",
                      fontSize: "20px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <span>
                      {faq.question.replace(/^(\d+\.\d+\.\s*)/, "")}
                    </span>
                    <span style={{
                      fontSize: "28px",
                      fontWeight: "bold"
                    }}>
                      {open === faq.id ? "−" : "+"}
                    </span>
                  </button>
                  {open === faq.id && (
                    <div style={{
                      background: "#1c5b9a",
                      padding: "20px 24px",
                      fontSize: "17px",
                      color: "#eee",
                      lineHeight: "2"
                    }}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))
            }
            {/* Section 3: Payments & Pricing */}
            {filteredFaqs.some(faq => faq.id.startsWith("faq-3-")) && (
              <h4 style={{ margin: "40px 0 24px 0", textAlign: "center", fontWeight:"bold" }}>
                Payments & Pricing
              </h4>
            )}
            {filteredFaqs
              .filter(faq => faq.id.startsWith("faq-3-"))
              .map(faq => (
                <div
                  key={faq.id}
                  style={{
                    background: "#1c5b9a",
                    color: "#fff",
                    borderRadius: "20px",
                    marginBottom: "18px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                    overflow: "hidden"
                  }}
                >
                  <button
                    onClick={() => handleToggle(faq.id)}
                    style={{
                      width: "100%",
                      background: "none",
                      border: "none",
                      color: "#fff",
                      textAlign: "left",
                      padding: "24px",
                      fontSize: "20px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <span>
                      {faq.question.replace(/^(\d+\.\d+\.\s*)/, "")}
                    </span>
                    <span style={{
                      fontSize: "28px",
                      fontWeight: "bold"
                    }}>
                      {open === faq.id ? "−" : "+"}
                    </span>
                  </button>
                  {open === faq.id && (
                    <div style={{
                      background: "#1c5b9a",
                      padding: "20px 24px",
                      fontSize: "17px",
                      color: "#eee",
                      lineHeight: "2"
                    }}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))
            }
            {/* Section 4: Posts and Promotions */}
            {filteredFaqs.some(faq => faq.id.startsWith("faq-4-")) && (
              <h4 style={{ margin: "40px 0 24px 0", textAlign: "center", fontWeight:"bold" }}>
                Posts and Promotions
              </h4>
            )}
            {filteredFaqs
              .filter(faq => faq.id.startsWith("faq-4-"))
              .map(faq => (
                <div
                  key={faq.id}
                  style={{
                    background: "#1c5b9a",
                    color: "#fff",
                    borderRadius: "20px",
                    marginBottom: "18px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                    overflow: "hidden"
                  }}
                >
                  <button
                    onClick={() => handleToggle(faq.id)}
                    style={{
                      width: "100%",
                      background: "none",
                      border: "none",
                      color: "#fff",
                      textAlign: "left",
                      padding: "24px",
                      fontSize: "20px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <span>
                      {faq.question.replace(/^(\d+\.\d+\.\s*)/, "")}
                    </span>
                    <span style={{
                      fontSize: "28px",
                      fontWeight: "bold"
                    }}>
                      {open === faq.id ? "−" : "+"}
                    </span>
                  </button>
                  {open === faq.id && (
                    <div style={{
                      background: "#1c5b9a",
                      padding: "20px 24px",
                      fontSize: "17px",
                      color: "#eee",
                      lineHeight: "2"
                    }}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))
            }
            {/* Section 5: Trust, Privacy & Safety */}
            {filteredFaqs.some(faq => faq.id.startsWith("faq-5-")) && (
              <h4 style={{ margin: "40px 0 24px 0", textAlign: "center", fontWeight:"bold" }}>
                Trust, Privacy & Safety
              </h4>
            )}
            {filteredFaqs
              .filter(faq => faq.id.startsWith("faq-5-"))
              .map(faq => (
                <div
                  key={faq.id}
                  style={{
                    background: "#1c5b9a",
                    color: "#fff",
                    borderRadius: "20px",
                    marginBottom: "18px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                    overflow: "hidden"
                  }}
                >
                  <button
                    onClick={() => handleToggle(faq.id)}
                    style={{
                      width: "100%",
                      background: "none",
                      border: "none",
                      color: "#fff",
                      textAlign: "left",
                      padding: "24px",
                      fontSize: "20px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <span>
                      {faq.question.replace(/^(\d+\.\d+\.\s*)/, "")}
                    </span>
                    <span style={{
                      fontSize: "28px",
                      fontWeight: "bold"
                    }}>
                      {open === faq.id ? "−" : "+"}
                    </span>
                  </button>
                  {open === faq.id && (
                    <div style={{
                      background: "#1c5b9a",
                      padding: "20px 24px",
                      fontSize: "17px",
                      color: "#eee",
                      lineHeight: "2"
                    }}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))
            }
            {/* Section 6: Platform Support */}
            {filteredFaqs.some(faq => faq.id.startsWith("faq-6-")) && (
              <h4 style={{ margin: "40px 0 24px 0", textAlign: "center", fontWeight:"bold" }}>
                Platform Support
              </h4>
            )}
            {filteredFaqs
              .filter(faq => faq.id.startsWith("faq-6-"))
              .map(faq => (
                <div
                  key={faq.id}
                  style={{
                    background: "#1c5b9a",
                    color: "#fff",
                    borderRadius: "20px",
                    marginBottom: "18px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                    overflow: "hidden"
                  }}
                >
                  <button
                    onClick={() => handleToggle(faq.id)}
                    style={{
                      width: "100%",
                      background: "none",
                      border: "none",
                      color: "#fff",
                      textAlign: "left",
                      padding: "24px",
                      fontSize: "20px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <span>
                      {faq.question.replace(/^(\d+\.\d+\.\s*)/, "")}
                    </span>
                    <span style={{
                      fontSize: "28px",
                      fontWeight: "bold"
                    }}>
                      {open === faq.id ? "−" : "+"}
                    </span>
                  </button>
                  {open === faq.id && (
                    <div style={{
                      background: "#1c5b9a",
                      padding: "20px 24px",
                      fontSize: "17px",
                      color: "#eee",
                      lineHeight: "2"
                    }}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))
            }
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FAQ;